/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuCategoriesDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-categories-dto';

export interface GetMenuCategoriesForVenue$Params {
  venueId?: string;
  isRemoved?: boolean;
  isMenuSubcategoryRemoved?: boolean;
  searchTerm?: string;
}

export function getMenuCategoriesForVenue(http: HttpClient, rootUrl: string, params?: GetMenuCategoriesForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuCategoriesForVenue.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
    rb.query('isRemoved', params.isRemoved, {});
    rb.query('isMenuSubcategoryRemoved', params.isMenuSubcategoryRemoved, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>;
    })
  );
}

getMenuCategoriesForVenue.PATH = '/api/menu-categories';
